<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>The Ark and Beyond</h1>
<h1 class="bk1">The Evolution of Zoo and Aquarium Conservation</h1>
<p class="bkau">Edited by Ben A. Minteer, Jane Maienschein, and James P. Collins</p>
<p class="bkau1" style="margin-top: 3em; margin-bottom: 0;">with a Foreword by</p>
<p class="bkau" style="margin-top: 0.5em;">GEORGE RABB</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">&amp;</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-minteer-0004.vue?4e1433fc